import React from "react";
import truckImage from "../../assets/images/Home/Chill-Freeze-Vans.png";

const GlobalCta = ({ title, description, paragraphs = [] }) => {
  return (
    <section
      className="py-5 d-flex align-items-center"
      style={{ backgroundColor: "#003366" }}
    >
      <div className="container-lg">
        <div className="row align-items-center">

          <div className="col-12 d-flex flex-column align-items-center mb-4 mb-lg-0">
            <h2
              className="h2-title text-center light-title"
              data-aos="fade-up"
              data-aos-delay="200"
              data-aos-duration="1400"
              data-aos-easing="ease-out-cubic"
            >
              {title}
            </h2>

            {paragraphs.length > 0
              ? paragraphs.map((p, i) => (
                  <p
                    key={i}
                    className="text-center text-light mt-3"
                    data-aos="fade-up"
                    data-aos-delay="300"
                    data-aos-duration="1400"
                    data-aos-easing="ease-out-cubic"
                  >
                    {p}
                  </p>
                ))
              : description && (
                  <p
                    className="text-center text-light mt-3"
                    data-aos="fade-up"
                    data-aos-delay="300"
                    data-aos-duration="1400"
                    data-aos-easing="ease-out-cubic"
                  >
                    {description}
                  </p>
                )}

            <a
              href="tel:+971544792905"
              className="btn--primary mt-4 bg-light text-dark"
              data-aos="fade-up"
              data-aos-delay="400"
              data-aos-duration="1400"
              data-aos-easing="ease-out-cubic"
            >
              Call Now
            </a>
          </div>

          <div className="col-12 text-center">
            <img
              src={truckImage}
              alt="Refrigerated chiller van rental service in Dubai UAE"
              className="img-fluid"
              loading="lazy"
              data-aos="fade-up"
              data-aos-delay="300"
              data-aos-duration="1400"
              data-aos-easing="ease-out-cubic"
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default GlobalCta;
